module.exports = __webpack_public_path__ + "static/media/hero-ilustrasi.3903564d.svg";